import { createSlice } from "@reduxjs/toolkit";

export const sideBar = createSlice({
  name: "activeModal",
  initialState: {
    data: "Dashboard",
  },
  reducers: {
    setActiveModal(state, action) {
      state.data = action.payload;
    },
  },
});

export const { setActiveModal } = sideBar.actions;
export default sideBar.reducer;
